import { Link } from "react-router-dom";
import styles from "./Footer.module.css";
import Icon from "./Icons";
import { areasServed } from "../data/content";
import { categories } from "../data/services";
import useBlogPosts from "../hooks/useBlogPosts";
import useSiteSettings from "../hooks/useSiteSettings";

/* Footer links the four service categories and top-level pages only.
   Individual physiotherapy services (6 of them) used to be listed
   here too, duplicating the nav dropdown one click away — that was
   the real reason the footer ran long. */
const baseColumns = [
  {
    title: "Services",
    links: [
      { to: "/physiotherapy", label: "Physiotherapy" },
      { to: `/${categories.osteopathy.slug}`, label: categories.osteopathy.label },
      { to: `/${categories.oriental.slug}`, label: categories.oriental.label },
      { to: `/${categories.fitness.slug}`, label: categories.fitness.label },
      { to: "/conditions", label: "Conditions Treated" },
    ],
  },
];

export default function Footer() {
  const { hasPosts } = useBlogPosts();
  const { doctor } = useSiteSettings();

  const columns = [
    ...baseColumns,
    {
      title: "Practice",
      links: [
        { to: "/faq", label: "FAQ" },
        ...(hasPosts ? [{ to: "/blog", label: "Health Insights" }] : []),
        { to: "/contact", label: "Book a Consultation" },
      ],
    },
  ];

  return (
    <footer className={styles.footer}>
      <div className={`u-shell ${styles.inner}`}>
        <div className={styles.top}>
          <div className={styles.brand}>
            <span className={styles.name}>Heal with Dr. Aakash</span>
            <span className={styles.role}>
              {doctor.credential} &middot; {doctor.role}
            </span>

            <ul className={styles.contact}>
              <li>
                <a href={`tel:${doctor.phoneHref}`}>
                  <Icon name="phone" size={16} />
                  {doctor.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${doctor.email}`}>
                  <Icon name="mail" size={16} />
                  {doctor.email}
                </a>
              </li>
              <li className={styles.place}>
                <Icon name="pin" size={16} />
                {doctor.location}
              </li>
            </ul>
          </div>

          <nav className={styles.columns} aria-label="Footer">
            {columns.map((col) => (
              <div key={col.title} className={styles.column}>
                <h2 className={styles.columnTitle}>{col.title}</h2>
                <ul>
                  {col.links.map((link) => (
                    <li key={link.to + link.label}>
                      <Link to={link.to} className={styles.link}>
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </nav>
        </div>

        <div className={styles.areas}>
          <h2 className={styles.areasTitle}>Serving</h2>
          <p className={styles.areasList}>
            {areasServed.join(" · ")} &mdash; and across Gurugram for home
            visits.
          </p>
        </div>

        <div className={styles.base}>
          <p className={styles.legal}>
            &copy; {new Date().getFullYear()} {doctor.name}. All rights
            reserved.
          </p>
          <p className={styles.disclaimer}>
            Information here is general and does not replace an individual
            clinical assessment.
          </p>
        </div>
      </div>
    </footer>
  );
}
